import React, { useState } from "react";
import NavBar from "../components/NavBar";
import { useSelector, useDispatch } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import "react-toastify/dist/ReactToastify.css";
import {
  sendEmailOtp,
  sendMobileOtp,
  trainingRegisterFrom,
} from "../../actions/home/home_action";
import { Link, useParams } from "react-router-dom";
import { trainingRegisterMessage } from "../../config/api";
import { Fragment } from "react";
const RegisterTrainingFrom = () => {
  const { slug } = useParams();
  const [isVerifiedMobile, setIsVerifiedMobile] = useState(false);
  const [isVerifiedEmail, setIsVerifieEmail] = useState(false);

  const [isVerifiedMobileMessage, setIsVerifiedMobileMessage] = useState("");
  const [isVerifiedEmailMessage, setIsVerifieEmailMessage] = useState("");
  const [isNotVerify, setNotVerify] = useState(false);
  const [student, setRegisterStudent] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    slug: slug,
    mobile_otp: "",
    email_otp: "",
  });
  const dispatch = useDispatch();
  const data = useSelector((state) => state.homeReducer);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isVerifiedMobile && isVerifiedEmail) {
      dispatch(trainingRegisterFrom(student));
    } else {
      setNotVerify(true);
    }
  };

  const handelMobileSendOtp = () => {
    setNotVerify(false);
    setIsVerifiedMobileMessage(" ");
    dispatch(sendMobileOtp({ mobile_no: student.mobile_no }));
  };

  const handelEmailSendOtp = () => {
    setNotVerify(false);
    dispatch(
      sendEmailOtp({ email: student.email, first_name: student.first_name })
    );
  };

  const verifyOtp = (type) => {
    setNotVerify(false);
    if (type === 1) {
      if (type === 1 && student.mobile_otp === window.atob(data.mobile_otp)) {
        setIsVerifiedMobileMessage("Mobile no is verified");
        setIsVerifiedMobile(true);
      } else {
        setIsVerifiedMobileMessage("Incorrect OTP try again");
      }
    }

    if (type === 2) {
      if (type === 2 && student.email_otp === window.atob(data.email_otp)) {
        setIsVerifieEmailMessage("Email is verified");
        setIsVerifieEmail(true);
      } else {
        setIsVerifieEmailMessage("Incorrect OTP try again");
      }
    }
  };

  return (
    <div>
      <LoadingOverlay active={data.loading} spinner text="Loading...">
        <NavBar />
        <div className="container org-reg top-margin pb-4">
          <div className="col-sm-12 pt-4 mb-5">
            <div className="card bg-theme-color shadow-lg rounded-lg ">
              <div className="card-body p-lg-5 p-4 w-100 border-0 shadow-lg">
                {data.is_done && (
                  <div class="alert alert-success">
                    <strong>
                      {trainingRegisterMessage} {"  "}
                      <Link to={"/login"} className="btn-common">
                        {" "}
                        Go To Login
                      </Link>
                    </strong>
                  </div>
                )}
                {data.errors.other_error && (
                  <div class="alert alert-danger">
                    <strong>{data.errors.other_error}</strong>
                  </div>
                )}

                {isNotVerify && (
                  <div class="alert alert-danger">
                    <strong>{"Verify Email Or Mobile No."}</strong>
                  </div>
                )}
                <h1 className={"mb-3"}>Training Register</h1>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          placeholder="First Name"
                          value={student.first_name}
                          onChange={(e) =>
                            setRegisterStudent({
                              ...student,
                              first_name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {data.errors.first_name ? data.errors.first_name : ""}{" "}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Last Name
                        </label>
                        <input
                          type="text"
                          required
                          placeholder="Enter Last Name"
                          className="form-control"
                          value={student.last_name}
                          onChange={(e) =>
                            setRegisterStudent({
                              ...student,
                              last_name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {data.errors.last_name ? data.errors.last_name : ""}{" "}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Email
                        </label>
                        <input
                          type="email"
                          required
                          placeholder="Enter Email"
                          className="form-control"
                          value={student.email}
                          onChange={(e) =>
                            setRegisterStudent({
                              ...student,
                              email: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {data.errors.email ? data.errors.email : ""}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <input
                        type="button"
                        value="Send OTP"
                        title="Send mobile number"
                        className="btn approve_btn btn-common pd-12 mt-40"
                        onClick={() => handelEmailSendOtp()}
                      />
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Mobile No
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control"
                          value={student.mobile_no}
                          placeholder="Mobile No"
                          onChange={(e) =>
                            setRegisterStudent({
                              ...student,
                              mobile_no: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {data.errors.mobile_no ? data.errors.mobile_no : ""}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <input
                        type="button"
                        value="Send OTP"
                        title="Send mobile number"
                        className="btn approve_btn btn-common pd-12 mt-40"
                        onClick={() => handelMobileSendOtp()}
                      />
                    </div>
                  </div>

                  <div className="row">
                    {data.email_otp && (
                      <Fragment>
                        <div className="col-lg-4 mb-3">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              Verify Email OTP
                            </label>
                            <input
                              type="text"
                              required
                              placeholder="Enter Email OTP"
                              className="form-control"
                              value={student.email_otp}
                              onChange={(e) => {
                                setRegisterStudent({
                                  ...student,
                                  email_otp: e.target.value,
                                });
                                setIsVerifieEmailMessage("");
                              }}
                            />
                            <span className="error-msg">
                              {isVerifiedEmailMessage}
                            </span>
                          </div>
                        </div>

                        <div className="col-lg-2">
                          <input
                            type="button"
                            value="Verify OTP"
                            title="Verify Email"
                            className="btn approve_btn btn-common pd-12 mt-40"
                            onClick={() => verifyOtp(2)}
                          />
                        </div>
                      </Fragment>
                    )}

                    {data.mobile_otp && (
                      <Fragment>
                        <div className="col-lg-4 mb-3">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              Verify Mobile OTP
                            </label>
                            <input
                              type="text"
                              required
                              className="form-control"
                              value={student.mobile_otp}
                              placeholder="Mobile No"
                              onChange={(e) => {
                                setRegisterStudent({
                                  ...student,
                                  mobile_otp: e.target.value,
                                });
                                setIsVerifiedMobileMessage("");
                              }}
                            />
                            <span className="error-msg">
                              {isVerifiedMobileMessage}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <input
                            type="button"
                            value="Verify OTP"
                            title="Verify mobile number"
                            className="btn approve_btn btn-common pd-12 mt-40"
                            onClick={() => verifyOtp(1)}
                          />
                        </div>
                      </Fragment>
                    )}
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group text-right">
                        <input
                          type="submit"
                          name="submit"
                          value="Register"
                          className="rounded-lg style1-input btn-common text-white text-center font-xss fw-500 border-2 border-0 p-0 w150"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default RegisterTrainingFrom;
